import React, { Component } from 'react'
import { Button } from 'antd';
import lockStyle from './index.css'

class LockPage extends Component {
  componentDidMount(){
    // sessionStorage.setItem('islock','1')
    // this.props.history.listenBeforeLeavingRoute()
    // console.log(this.props)
    // this.props.router.setRouteLeaveHook(this.props.route, (nextLocation) => {
    //   console.log('不让走-----------------')
    //   // if (nextLocation.pathname.indexOf('wxConcernSuccess') >= 0) {
    //   //   console.log('我离开了')
    //   // }
    //   // return false
    // })
  }
  unlock = () => {
    // sessionStorage.setItem('islock','0')
    // browserHistory.goBack()
  }
  render() {
    // console.log(this.props)
    return (
      <div className={lockStyle.outer}>
        <h2>LockPage</h2>
        <Button onClick={this.unlock} type="primary">解 锁</Button>
      </div>
    )
  }
}

export default LockPage


// WEBPACK FOOTER //
// ./apps/pages/lock/LockPage.js